import { render, staticRenderFns } from "./CustomTextField.vue?vue&type=template&id=7bfef989&scoped=true&"
import script from "./CustomTextField.vue?vue&type=script&lang=ts&"
export * from "./CustomTextField.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTextField.vue?vue&type=style&index=0&id=7bfef989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfef989",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
